export default __webpack_public_path__ + "static/irina-maizlish-92ce88fb5d9b66460b296427ebf0be6f.jpg";